import { Fragment } from 'react';
import { Container } from '@/components/container';

import { DashboardNewUserContent } from './';

const DashboardNewUserPage = () => {
  return (
    <Fragment>
      <Container>
        <DashboardNewUserContent />
      </Container>
    </Fragment>
  );
};

export { DashboardNewUserPage };
